import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, } from "../../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { useService } from "../../../context/ServiceContext";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";

import { verifyPanPlusService } from "../../../Services/ApiTestService/panTestService";
import { PanVerficationPlusData } from "../data2";
import { FaCopy } from "react-icons/fa";

const PanVerificationPlus = () => {
    const [panNumber, setPanNumber] = useState("");
    const {serviceName}  = useService();
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [panDetails, setPanDetails] = useState(null);

    const handleSubmit = async () => {
        try {
            if (panNumber === "") {
                errors.panNumber = 'PAN number is required.';
                return
            } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber.toUpperCase())) {
                errors.panNumber = 'Enter a valid PAN number (e.g., ABCDE1234F).';
                return
            }
            const payload = {

                "api_id": profileData?.user_id,
                "api_key": profileData?.api_key,
                "token_id": profileData?.token_id,

                "pan": panNumber,

            }
            setIsLoading(true);
            setErrors({})
            let response = await verifyPanPlusService(payload);
            //let response = PanVerficationPlusData
            setIsLoading(false)
            if (response.status.code === 200) {

                setPanDetails(response.data)
                showSuccessToast(response.message || response.data.message || "Pan Verified successfully");

            } else {
                showErrorToast(response.message || response.data.message || response.error.message || "Failed to verify pan ")
            }
        } catch (error) {
            setIsLoading(false);
            showErrorToast('Something went wrong')
        }
    }


    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }

    // Fetch Profile Data on Mount
    useEffect(() => {
        async function fetchProfileData() {
            try {
                setIsLoading(true);
                const response = await fetchProfile(); // API call to get profile details
                setProfileData(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching profile data", error);
                showErrorToast("Failed to fetch profile data.");
                setIsLoading(false);
            }
        }
        fetchProfileData();
    }, []);

    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />


            {/* Go Back Button */}
            <div className="w-full md:w-auto flex justify-end md:justify-end order-1">
                <Link
                    to="/TestMaster"
                    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-2 py-1 rounded-md font-semibold shadow-md transition duration-300"
                >
                    <span>Go Back</span>
                    <IoArrowBackCircleOutline size={24} />
                </Link>
            </div>
            <div className="flex flex-wrap gap-3 justify-start md:ml-64 ml-0">


                {/* Aadhar Number Input */}
                <div className="w-full md:w-1/6 order-2">
                    <InputWithLabel
                        type="text"
                        label="Pan Number"
                        placeholder="Enter Pan No"
                        maxLength={12}
                        className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full uppercase"
                        name="panNo"
                        id="panNo"
                        required={true}
                        value={panNumber}
                        onChange={(e) => setPanNumber(e.target.value)}
                        error={errors.panNumber}
                    />

                </div>


                <div className="w-full md:w-auto order-3">
                    <Button
                        type="button"
                        className="text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 hover:from-blue-900 hover:to-blue-400 border-4"
                        id="verifyPan"
                        name="verifyPan"
                        text="Verify Pan"
                        onClick={handleSubmit}
                    />
                </div>


            </div>
            <div className="flex justify-btween gap-2">
                <div>
                    {panDetails && Object.keys(panDetails).length > 0 && (
                        <>
                            <div className="flex justify-center">
                                <h2 className="font-bold text-2xl mt-4">PAN Details</h2>
                            </div>
                            <div className="border border-gray-300 rounded-lg p-4 mt-1 shadow-inner shadow-blue-600">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-lg gap-4">
                                    {[
                                        { label: "Name", value: panDetails?.fullname },
                                        { label: "Pan Number", value: panDetails?.pan },
                                        { label: "Pan Type", value: panDetails?.pan_type },
                                        { label: "Gender", value: panDetails.gender },
                                        { label: "Aadhar Number", value: panDetails?.aadhaar_number || "N/A" },
                                        { label: "Aadhar Link", value: panDetails?.aadhaar_linked ? "YES" : "NO" },
                                        { label: "Date of Birth", value: panDetails?.dob },
                                        { label: "Mobile", value: panDetails?.mobile || "N/A" },
                                        { label: "Email", value: panDetails?.email || "N/A" },
                                        { label: "PAN Status", value: panDetails?.pan_status },
                                        { label: "PAN Allotment Date", value: panDetails?.pan_allotment_date },
                                        { label: "Is Salaried", value: panDetails?.is_salaried === "Y" ? "Yes" : "No" },
                                        { label: "Is Director", value: panDetails?.is_director === "Y" ? "Yes" : "No" },
                                    ].map(({ label, value }) => (
                                        <div key={label} className="px-2">
                                            <span className="font-semibold">{label}:</span> {value || "N/A"}
                                        </div>
                                    ))}
                                </div>

                                {/* Signatory Details Section */}
                                {panDetails.signatory_details && panDetails.signatory_details.length > 0 && (
                                    <>
                                        <div className="flex justify-center mt-6">
                                            <h3 className="font-semibold text-xl">Signatory Details</h3>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                                            {panDetails.signatory_details.map((signatory, idx) => (
                                                <div key={idx} className="border p-4 rounded-lg shadow-md bg-gray-50">
                                                    {Object.entries(signatory).map(([key, value]) => (
                                                        <div key={key} className="mb-2">
                                                            <span className="font-semibold capitalize">{key.replace(/_/g, ' ')}:</span>{" "}
                                                            {value || "N/A"}
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
                {panDetails && Object.keys(panDetails).length > 0 && (

                    <pre className="bg-black w-1/2 relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                        <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(panDetails)} />
                        {JSON.stringify(panDetails, null, 2)}
                    </pre>

                )}
            </div>

            <div class="max-w-3xl mx-auto p-1 md:p-1 bg-white rounded-3xl shadow-2xl mt-1 border border-gray-200 transition-transform duration-300 hover:scale-[1.01]">
                <h2 class="text-2xl font-extrabold text-center text-gray-900 mb-3 tracking-tight">
                    🔐 Pan Verification Steps
                </h2>

                <ol class="list-decimal text-gray-800 space-y-3 pl-6 relative">
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block group-hover:text-blue-600 transition-colors duration-300">
                            Enter your <span class="font-medium text-gray-900">10-digit Pan number</span> carefully.
                        </span>
                    </li>
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block">
                            Click on <span class="font-semibold text-blue-600 underline underline-offset-2 group-hover:text-blue-800 transition-colors duration-300">“Submit ”</span> to verify your pan number.
                        </span>
                    </li>



                </ol>

                <div class="mt-6 border-t border-gray-300 pt-1">
                    <h3 class="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2">
                        📌 Important Notes
                        <span class="text-yellow-500 animate-pulse text-lg">⚠️</span>
                    </h3>
                    <ul class="list-disc text-gray-700 space-y-2 pl-6">
                        <li class="hover:text-blue-600 transition duration-300">
                            Ensure the correct pan number .
                        </li>
                        <li class="hover:text-blue-600 transition duration-300">
                            Do not refresh the page during the verification process.
                        </li>

                    </ul>
                </div>
            </div>



        </>
    );
};

export default PanVerificationPlus;  